import React from 'react';
import { DIAS_SEMANA_CURTO, agruparSemanas, formatDataCurta } from './escalaUtils';

/**
 * Grade semanal da escala (segunda → sexta, ou → domingo), no formato da
 * escala impressa: cada célula é um dia com os turnos empilhados. O que vai
 * dentro de cada turno quem decide é a tela (admin escala/aprova; o
 * itinerante pede vaga), via `renderTurno(dia, turno)`.
 */
const EscalaGrade = ({
  dias,
  turnos,
  mostrar = { sabado: false, domingo: false },
  renderTurno,
  onDiaClick,
  cabecalhoDia,
}) => {
  const { colunas, semanas } = agruparSemanas(dias, mostrar);
  if (semanas.length === 0) {
    return <div className="esc-grade-vazia">Nenhum dia no período.</div>;
  }
  return (
    <div className={`esc-grade esc-grade-${colunas.length}`}>
      <div className="esc-grade-cabecalho">
        {colunas.map((c) => (
          <div key={c} className={`esc-grade-coluna ${c === 0 || c === 6 ? 'fds' : ''}`}>
            {DIAS_SEMANA_CURTO[c]}
          </div>
        ))}
      </div>
      {semanas.map((semana) => (
        <div className="esc-semana" key={semana.chave}>
          {semana.celulas.map((dia, idx) => {
            if (!dia) {
              return <div key={`${semana.chave}-${idx}`} className="esc-dia esc-dia-vazio" />;
            }
            const classes = [
              'esc-dia',
              dia.feriado ? 'feriado' : '',
              dia.passado ? 'passado' : '',
              dia.hoje ? 'hoje' : '',
              onDiaClick ? 'clicavel' : '',
            ]
              .filter(Boolean)
              .join(' ');
            return (
              <div
                key={dia.id}
                className={classes}
                onClick={onDiaClick ? () => onDiaClick(dia) : undefined}
                role={onDiaClick ? 'button' : undefined}
                tabIndex={onDiaClick ? 0 : undefined}
                onKeyDown={
                  onDiaClick
                    ? (e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          onDiaClick(dia);
                        }
                      }
                    : undefined
                }
              >
                <div className="esc-dia-topo">
                  <span className="esc-dia-semana">{DIAS_SEMANA_CURTO[dia.diaSemana]}</span>
                  <span className="esc-dia-data">{formatDataCurta(dia.data)}</span>
                  {dia.hoje && <span className="esc-dia-hoje">hoje</span>}
                  {cabecalhoDia && cabecalhoDia(dia)}
                </div>
                {dia.feriado ? (
                  <div className="esc-feriado">
                    <span className="esc-feriado-rotulo">FERIADO</span>
                    {dia.descricao && <span className="esc-feriado-desc">{dia.descricao}</span>}
                  </div>
                ) : (
                  <>
                    {dia.descricao && <div className="esc-dia-desc">{dia.descricao}</div>}
                    <div className="esc-dia-turnos">
                      {turnos.map((t) => {
                        const turno = dia.turnos.find((x) => x.turno === t.key);
                        if (!turno) return null;
                        return (
                          <div key={t.key} className={`esc-turno esc-turno-${t.key}`}>
                            {renderTurno(dia, turno, t)}
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default EscalaGrade;
